import React from "react";
import clx from "classnames";

import { Dataset } from "../types/ChartData";

import Typography from "../../common/Typography/Typography";
import ButtonNoStyles from "../../common/Buttons/ButtonNoStyles/ButtonNoStyles";

interface Props {
    legend: {
        label: string;
        backgroundColor: string;
        hidden: boolean;
    }[];
    onClick?: (label: Dataset["label"]) => void;
}

const Legend = ({ legend, onClick }: Props) => (
    <ul className="flex flex-wrap gap-2">
        {legend.map(({ label, hidden, backgroundColor }) => {
            const handleClick = onClick ? () => onClick(label) : undefined;
            const className = clx("transition-opacity", hidden ? "opacity-30" : undefined);

            return (
                <li key={label} className={className}>
                    <ButtonNoStyles
                        type="button"
                        onClick={handleClick}
                        className="flex items-center gap-0.5 cursor-pointer"
                        title={hidden ? `Show ${label}` : `Hide ${label}`}
                    >
                        <Typography as="span" variant="smallCaps">
                            {label}
                        </Typography>
                        <span className="w-1 h-1 rounded-full" style={{ backgroundColor }} />
                    </ButtonNoStyles>
                </li>
            );
        })}
    </ul>
);

export default Legend;
